import { useForm, FormProvider } from "react-hook-form";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { EmailFormField, TermsFormField } from "@/components/molecules";
import React, { useEffect, useState } from "react";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { SignInLink } from "@/components/atoms/SignInLink";

export type StartUsingMikatanoBFMFormValues = {
  email: string;
  termOfUse: boolean;
  specialTerm: boolean;
  privacyPolicy: boolean;
  adEmailDelivery: boolean;
};

type Props = {
  onSubmit: (formValues: StartUsingMikatanoBFMFormValues) => void;
};

export const StartUsingMikatanoBFMForm = (props: Props) => {
  const isSpMode = useIsSpMode();

  const methods = useForm<StartUsingMikatanoBFMFormValues>({
    reValidateMode: "onBlur",
  });

  const [agreed, setAgreed] = useState(false);

  const formValues = methods.getValues();
  useEffect(() => {
    setAgreed(
      formValues.termOfUse &&
        formValues.specialTerm &&
        formValues.privacyPolicy &&
        formValues.adEmailDelivery
    );
  }, [formValues]);

  return (
    <>
      <div css={container}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(props.onSubmit)} css={formCSS}>
            <div css={!isSpMode ? borderBox : borderSpModeBox}>
              <div css={!isSpMode ? inputList : spModeInputList}>
                <div css={listItem}>
                  <EmailFormField
                    name="email"
                    itemName={"資金管理オーナー様ID\n(メールアドレス)"}
                  />
                </div>
              </div>
            </div>
            <div css={!isSpMode ? box : spModeBox}>
              <div css={textAlignCenter}>
                （オーナー以外の利用者ID発行は、
                <br />
                オーナー様ログイン後の画面で行います）
              </div>
            </div>
            <div css={!isSpMode ? box : spModeBox}>
              <div css={listItem}>
                <TermsFormField
                  termOfUse="termOfUse"
                  specialTerm="specialTerm"
                  privacyPolicy="privacyPolicy"
                  adEmailDelivery="adEmailDelivery"
                />
              </div>
            </div>
            <div css={buttonWrapper}>
              <Button
                type="submit"
                disabled={methods.formState.isSubmitting || !agreed}
              >
                登録
              </Button>
            </div>
            <div css={!isSpMode ? box : spModeBox}>
              ※規約に同意いただけない場合は、サービスを利用開始することができませんので何卒ご了承ください。
            </div>
          </form>
        </FormProvider>
      </div>
      <div css={signInLink}>
        <SignInLink />
      </div>
    </>
  );
};

const signInLink = css({
  marginTop: "24px",
  textAlign: "center",
});

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  padding: "32px 32px 8px",
  margin: "0 auto",
});

const spModeBox = css({
  padding: "15px 17px",
});

const borderBox = css(box, {
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const borderSpModeBox = css(spModeBox, {
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const formCSS = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",

  paddingTop: "8px",
  paddingBottom: "16px",
});

const inputList = css({
  flex: 1,
});

const spModeInputList = css({
  flex: 1,
});

const listItem = css({
  marginBottom: "25px",
});

const buttonWrapper = css({
  margin: "8px auto",
});

const textAlignCenter = css({
  textAlign: "center",
});
